import { FC } from 'react';

interface RoundedIconProps {
    children: React.ReactNode;
    color: string;
    width: string;
    height: string;
}
 
const RoundedIcon: FC<RoundedIconProps> = ({children, color, height, width}) => {
    return (<div className={`${height} ${width} flex justify-center items-center border-[1px] rounded-full p-2 mr-2 border-[${color}]]`}>{children}</div>);
}
 
export default RoundedIcon;